import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from '../../Button';
import remove from '../../../images/cancel.svg';

class SelectedItemDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded || false,
    };
  }
  toggleExpansion() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  renderEditMode() {
    const { index, removeItem, arrayItems, template, controlList, cdf, onChange, storedList } = this.props;
    const title = this.props.getTitle(arrayItems);
    return (
      <Div className="modal-item" expand={this.state.expanded}>
        <Header onClick={() => this.toggleExpansion()}>
          <Title>{title}</Title>
          <RightAlignedButton mode={this.props.mode} expand={this.state.expanded} className="toggle" key="expand" onClick={() => this.toggleExpansion()}><i className="glyphicon glyphicon-chevron-down"></i></RightAlignedButton>
          <RightAlignedButton mode={this.props.mode} className="remove-item" key="removeItem" data-index={index} onClick={removeItem}><i className="glyphicon glyphicon-remove"></i></RightAlignedButton>
        </Header>
        <MultiSelectContent>{React.createElement(template, { arrayItems, controlList, cdf, updateCDF: this.props.updateCDF, index, onChange, storedList })}</MultiSelectContent>
      </Div>
    );
  }

  renderDisplayMode() {
    const { index, removeItem, arrayItems } = this.props;
    const title = this.props.getTitle(arrayItems);
    return (
      <Div expand={this.state.expanded}>
        <Title>{title}</Title>
        <RightAlignedButton mode={this.props.mode} className="remove-item" key="removeItem" data-index={index} onClick={removeItem}></RightAlignedButton>
      </Div>
    );
  }

  render() {
    switch (this.props.mode) {
      case 'edit':
        return this.renderEditMode();
      case 'display':
        return this.renderDisplayMode();
      default:
        return null;
    }
  }
}

SelectedItemDisplay.propTypes = {
  arrayItems: PropTypes.array,
  removeItem: PropTypes.func,
  index: PropTypes.number,
  mode: PropTypes.oneOf([
    'display',
    'edit',
  ]),
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  template: PropTypes.func,
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  updateCDF: PropTypes.func,
  getTitle: PropTypes.func,
  storedList: PropTypes.array,
};

const Div = styled.div`
  background-color: rgb(224, 224, 224);
  margin: 6px 0;
  transition: height 0.5s;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 15px;
  position: relative;
  &:first-child{
    margin-top: 0px;
    margin-bottom: 10px !important;
  }
  &:last-child{
    margin-bottom: 10px;
  }
  ${(props) => `
    ${props.expand ? 'height: 500px;' : 'height: 50px;'}
  `}
  &.modal-item{
    background-color: white;
    border: 1px solid ${(props) => props.theme.lightGrey};
    min-height: 50px;
    padding: 0;
    p{
      height: 50px;
      padding: 13px 10px;
      font-size: 16px;
    }
  }
`;

const Header = styled.div`
  display: block;
  width: 100%;
  height: 50px;
  cursor: pointer;
`;

const Title = styled.p`
  display: inline-block;
  font-size: 14px;
  float: left;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 85%;
  margin-bottom: 0;
`;

const RightAlignedButton = styled(Button)`
  position: absolute;
  ${(props) => {
    switch (props.mode) {
      case 'display':
        return `
          right: 10px;
          width: 20px;
          height: 20px;
          padding: 0;
          border-left: 0;
          background-image: url(${remove});
          --default-background: ${props.theme.red};
          --hover-background: #ff0000;
`;
      case 'edit':
        return `
          right: 40px;
          width: 40px;
          height: 50px;
          padding: 15px 13px;
          border-left: 1px solid ${props.theme.lightGrey};
          background-image: none;
          --default-color: ${props.theme.brandPurple};
          --default-background: transparent;
          --hover-color: ${props.theme.brandDark};
          --hover-background: transparent;

          &.remove-item {
            --default-color: ${props.theme.red};
            --hover-color: #ff0000;
          }
`;
      default: return null;
    }
  }}
  background-size: 12px;
  background-repeat: no-repeat;
  background-position: center;
  transition: background-color 0.5s, color 0.5s;
  i{
    transition: transform 0.5s, color 0.5s;
    ${(props) => `
      ${props.expand ? 'transform: rotate(180deg);' : 'transform: rotate(0deg);'}
`}
    &.glyphicon-minus{
      &:before{
        content: "\\e082";
      }
    }
  }
  &.toggle{
    right: 0 !important;
  }
`;

const MultiSelectContent = styled.div`
  background-color: #efefef;
  padding: 30px;
  height: 100%;
  select[multiple]{
    padding: 10px;
    width: 49%;
    height: 250px;
    &:first-child{
      margin-right: 2%;
    }
  }
`;

export default SelectedItemDisplay;



// WEBPACK FOOTER //
// ./app/components/FormControls/ListEditor/SelectedItemDisplay.js